import React from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import { withStyles, withTheme } from '@glu/theming';
import EveryN, { NUMBER } from './EveryN';
import { types } from './Recurrence.reducer';

const styles = {
  minutesHours: {},
  example: {
    marginBottom: 20
  }
};

const MinutesHours = ({
  classes, value, min, max, everyText, exactStep, step, type, getExampleText, onChange
}) => (
  <div data-qa="minutesHours" className={classes.minutes}>
    <EveryN
      {...{
        min, max, everyText, exactStep, step, value
      }}
      onChange={(name, response) => onChange({
        type,
        response
      })}
      type={NUMBER}
    />
    <div className={classes.example}>
      {locale.get('schedulerReact.forExample', getExampleText(value).map(v => ` ${v.format('h:mm A')}`))}
    </div>
  </div>
);

MinutesHours.propTypes = {
  /** Classes provided by the theme */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /** Text to display in EveryN component */
  everyText: PropTypes.instanceOf(Array).isRequired,

  /** Disable manual entry of value. The user can change the value only by +- buttons */
  exactStep: PropTypes.bool,

  /** Value of every x interval */
  value: PropTypes.number,

  /** Min Value */
  min: PropTypes.number,

  /** Max Value */
  max: PropTypes.number,

  /** Value to increment with */
  step: PropTypes.number,

  /** Type of minutes or hours */
  type: PropTypes.oneOf([types.MINUTES, types.HOURLY]).isRequired,

  /** Example Text Method */
  getExampleText: PropTypes.func.isRequired,

  /** Callback to set recurrence value */
  onChange: PropTypes.func.isRequired
};

MinutesHours.defaultProps = {
  exactStep: false,
  step: 1,
  value: 1,
  min: 1,
  max: 1
};

export const BareMinutesHours = MinutesHours;
export default withTheme(withStyles(styles)(MinutesHours));
